<div class="game-panel-container w-100 d-flex flex-column align-items-center">
  <div class="game-details d-flex flex-column w-100">
    <ng-container *ngIf="isFutureGame; else currentGameDetails">
      <div class="game-window-time future-game font-size-12 d-flex flex-row align-items-center justify-content-center">
        {{ 'fantasy.game.window.opens' | translate }}
        <fgbcl-countdown
          class="font-size-12 fw-bold"
          [endDateTime]="gameDisplayed.StartDate"
          [displayMinutes]="true"
        ></fgbcl-countdown>
      </div>
    </ng-container>
    <ng-template #currentGameDetails>
      <div class="game-window-time font-size-12 d-flex flex-row align-items-center justify-content-center">
        {{ 'fantasy.game.window.closes' | translate }}
        <fgbcl-countdown
          class="font-size-12 fw-bold"
          [endDateTime]="gameDisplayed.EndDate"
          [displayMinutes]="true"
          (complete)="onGameEnds($event)"
        ></fgbcl-countdown>
      </div>
    </ng-template>

    <div class="teams-container d-flex flex-column align-items-center">
      <div class="teams-details">
        <div class="team-item home-team d-flex flex-row align-items-center justify-content-end">
          <p class="team-name font-size-14 fw-bold text-white text-capitalize mb-0 text-end">{{ gameDisplayed.HomeTeamName }}</p>

          <ng-container *ngIf="gameDisplayed.HomeTeamLogo; else noHomeImage">
            <img src="{{ gameDisplayed.HomeTeamLogo | contentImage: '7' }}" alt="home team" />
          </ng-container>
          <ng-template #noHomeImage>
            <img [src]="'placeholders/fallbackteamlogo.svg' | contentAssetImage" alt="home team" />
          </ng-template>
        </div>
        <span class="font-size-14 fw-bold text-white text-uppercase">{{ 'fantasy.game.vs' | translate }}</span>
        <div class="team-item away-team d-flex flex-row align-items-center justify-content-start">
          <ng-container *ngIf="gameDisplayed.AwayTeamLogo; else noAwayImage">
            <img src="{{ gameDisplayed.AwayTeamLogo | contentImage: '7' }}" alt="away team" />
          </ng-container>
          <ng-template #noAwayImage>
            <img [src]="'placeholders/fallbackteamlogo.svg' | contentAssetImage" alt="home team" />
          </ng-template>
          <p class="team-name font-size-14 fw-bold text-white text-capitalize mb-0 text-start">
            {{ gameDisplayed.AwayTeamName }}
          </p>
        </div>
      </div>

      <p class="font-size-12 text-white mb-0">{{ gameDate }} - {{ gameTime }}</p>
    </div>
  </div>
</div>

<div
  *ngIf="gameDisplayed.Sponsor?.SponsorId"
  class="sponsor-container w-100 d-flex flex-row align-items-center justify-content-center text-white"
>
  {{ 'fantasy.game.sponsored.by' | translate }}
  <ng-container *ngIf="gameDisplayed.Sponsor?.SponsorImage; else brokenImg">
    <img src="{{ gameDisplayed.Sponsor.SponsorImage | contentImage: '1' }}" alt="{{ gameDisplayed.Sponsor?.SponsorText }}" />
  </ng-container>
  <ng-template #brokenImg><span class="material-symbols-outlined"> broken_image </span></ng-template>
</div>

<ng-container *ngIf="!isFutureGame">
  <fgb-fantasy-player-select-v2
    [gameEnds]="gameEnds"
    [gameDetails]="gameDetails"
    [gameId]="gameDisplayed.GameId"
  ></fgb-fantasy-player-select-v2>
</ng-container>
